import { Toast } from "primereact/toast";
import { useRef } from "react";

function FileDropArea(props) {
  const { children, onDrop, formats, validExtensions, disabled } = props;
  const fileInputRef = useRef(null);

  const extensions = formats.flat();

  function isValidFile(file) {
    return (
      (validExtensions || extensions).filter((extension) =>
        file.name.toLowerCase().endsWith(extension)
      ).length > 0
    );
  }
  const sendFiles = (files) => {
    onDrop(files.filter(isValidFile));
  };
  const MAX_FILE_SIZE = 5000000;
  const toast: any = useRef();
  const processFilesAndSend = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const ret = [];
    if (ev.dataTransfer.items) {
      for (let i = 0; i < ev.dataTransfer.items.length; i++) {
        if (ev.dataTransfer.items[i].kind === "file") {
          const file = ev.dataTransfer.items[i].getAsFile();
          ret.push(file);
        }
      }
    } else {
      for (let j = 0; j < ev.dataTransfer.files.length; j++) {
        ret.push(ev.dataTransfer.files[j]);
      }
    }
    sendFiles(ret);
  };

  const onFileChange = (event) => {
    Array.from(event.target.files).forEach((file: any) => {
      if (file.size > MAX_FILE_SIZE) {
        toast.current.show({
          severity: "warn",
          summary: "Tamaño de archivo",
          detail: "Inválido",
        });

        const error = { code: "files is too big!" };
        throw error;
      }
    });
    sendFiles([...event.target.files]);
    event.target.value = "";
  };
  return (
    <div
      className="file-drop-area"
      onDragOver={(e) => e.preventDefault()}
      onDrop={processFilesAndSend}
      onClick={() => fileInputRef.current.click()}
    >
      <Toast ref={toast}></Toast>
      <input
        ref={fileInputRef}
        accept={extensions ? extensions.join(",") : ""}
        style={{ display: "none" }}
        type="file"
        onChange={onFileChange}
        multiple={true}
        disabled={disabled}
      />
      {children}
    </div>
  );
}

export default FileDropArea;
